import { createSlice } from "@reduxjs/toolkit";

/**
 * 파일명: drawerPopupSlice.js
 * 작성자: 강연승
 * 작성일자: 25.02.27
 * 설명:
 */
const drawerPopupSlice = createSlice({
  name: "popupSlice",
  initialState: {
    display: false,
    type: "",
  },
  reducers: {
    openPopup: (state, action) => {
      state.display = true;
      state.type = action.payload.type;
    },
    closePopup: (state) => {
      state.display = false;
    },
  },
});

export default drawerPopupSlice;

export const { openPopup, closePopup } = drawerPopupSlice.actions;
